import { useTranslation } from 'react-i18next';
import { TrendingUp, CheckCircle2, AlertTriangle } from 'lucide-react';

export default function WeeklySummaryCard({ weekly }) {
  const { t } = useTranslation();
  if (!weekly || (weekly.completed === 0 && weekly.failed === 0)) return null;
  return (
    <div className="gm-card p-4 mt-4" data-testid="weekly-summary-card">
      <div className="flex items-center gap-2 mb-2">
        <TrendingUp size={18} color="#1CB0F6" strokeWidth={3} />
        <p className="text-xs uppercase font-extrabold text-[#AFAFAF] tracking-wider"> {t('c.dashboard.WeeklySummaryCard.last_period_days_days', { period_days: weekly.period_days })} </p>
        <span className="ml-auto text-xs font-extrabold text-[#58CC02]">
          {weekly.completed} {t('c.dashboard.WeeklySummaryCard.done_failed_skipped', { failed: weekly.failed })} </span>
      </div>
      <p className="text-sm font-extrabold leading-snug text-[#4B4B4B]" data-testid="weekly-highlight">
        {weekly.highlight}
      </p>

      {weekly.wins.length > 0 && (
        <div className="mt-3">
          <p className="text-[10px] uppercase font-extrabold text-[#58CC02] tracking-wider flex items-center gap-1">
            <CheckCircle2 size={11} strokeWidth={3} /> {t('c.dashboard.WeeklySummaryCard.wins')} </p>
          <div className="flex flex-wrap gap-1.5 mt-1.5" data-testid="weekly-wins">
            {weekly.wins.slice(0, 4).map((w) => (
              <span
                key={w.label}
                className="px-2.5 py-1 rounded-full text-[11px] font-extrabold bg-[#E8F8D8] text-[#58CC02] border border-[#58CC02]"
              >
                {w.label} <span className="opacity-70">×{w.count}</span>
              </span>
            ))}
          </div>
        </div>
      )}

      {weekly.blockers.length > 0 && (
        <div className="mt-3">
          <p className="text-[10px] uppercase font-extrabold text-[#FF8E2C] tracking-wider flex items-center gap-1">
            <AlertTriangle size={11} strokeWidth={3} /> {t('c.dashboard.WeeklySummaryCard.blockers')} </p>
          <div className="flex flex-wrap gap-1.5 mt-1.5" data-testid="weekly-blockers">
            {weekly.blockers.map((b) => (
              <span
                key={b.label}
                className="px-2.5 py-1 rounded-full text-[11px] font-extrabold bg-[#FFF1E6] text-[#FF8E2C] border border-[#FF8E2C]"
              >
                {b.label} <span className="opacity-70">×{b.count}</span>
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
